import axios from 'axios'

const BASE_URL = import.meta.env.VITE_API_BASE_URL

const getRequestConfig = () => {
  const STORAGE_TOKEN = JSON.parse(window.localStorage.getItem('token'))

  return {
    headers: {
      Authorization: 'Bearer ' + STORAGE_TOKEN,
    },
    withCredentials: true,
  }
}

export const getAllPrompts = async () => {
  const config = getRequestConfig()

  return await axios
    .get(`${BASE_URL}prompts-management`, config)
    .then((response) => {
      return {
        data: response.data,
        responseStatus: response.status,
      }
    })
    .catch(function (error) {
      if (error?.response?.status === 401) {
        window.localStorage.clear()
        window.location.reload()
      }
      console.log('error getAllPrompts', error?.response?.data || error)
      return error
    })
}

export const createPrompt = async (payload) => {
  const config = getRequestConfig()

  return await axios
    .post(`${BASE_URL}prompts-management`, payload, config)
    .then((response) => {
      return {
        data: response.data,
        responseStatus: response.status,
      }
    })
    .catch(function (error) {
      if (error?.response?.status === 401) {
        window.localStorage.clear()
        window.location.reload()
      }
      console.log('error createPrompt', error?.response?.data || error)
      return error
    })
}

export const updatePromptById = async (id, payload) => {
  const config = getRequestConfig()

  return await axios
    .put(`${BASE_URL}prompts-management/${id}`, payload, config)
    .then((response) => {
      return {
        data: response.data,
        responseStatus: response.status,
      }
    })
    .catch(function (error) {
      if (error?.response?.status === 401) {
        window.localStorage.clear()
        window.location.reload()
      }
      console.log('error updatePromptById', error?.response?.data || error)
      return error
    })
}

export const getPromptCommits = async (promptManagementId) => {
  const config = getRequestConfig()

  return await axios
    .get(
      `${BASE_URL}prompt-commits?promptManagementId=${encodeURIComponent(promptManagementId)}`,
      config,
    )
    .then((response) => {
      return {
        data: response.data,
        responseStatus: response.status,
      }
    })
    .catch(function (error) {
      if (error?.response?.status === 401) {
        window.localStorage.clear()
        window.location.reload()
      }
      console.log('error getPromptCommits', error?.response?.data || error)
      return error
    })
}

export const syncPrompts = async (names) => {
  const config = getRequestConfig()

  return await axios
    .post(`${BASE_URL}prompts-management/sync`, {names}, config)
    .then((response) => {
      return {
        data: response.data,
        responseStatus: response.status,
      }
    })
    .catch(function (error) {
      if (error?.response?.status === 401) {
        window.localStorage.clear()
        window.location.reload()
      }
      console.log('error syncPrompts', error?.response?.data || error)
      return error
    })
}

export const getSyncStatus = async () => {
  const config = getRequestConfig()

  return await axios
    .get(`${BASE_URL}prompts-management/sync-status`, config)
    .then((response) => {
      return {
        data: response.data,
        responseStatus: response.status,
      }
    })
    .catch(function (error) {
      if (error?.response?.status === 401) {
        window.localStorage.clear()
        window.location.reload()
      }
      console.log('error getSyncStatus', error?.response?.data || error)
      return error
    })
}

export const syncAllFromHomolog = async () => {
  const config = getRequestConfig()

  return await axios
    .post(`${BASE_URL}prompts-management/sync-all-from-homolog`, {}, config)
    .then((response) => {
      return {
        data: response.data,
        responseStatus: response.status,
      }
    })
    .catch(function (error) {
      if (error?.response?.status === 401) {
        window.localStorage.clear()
        window.location.reload()
      }
      console.log('error syncAllFromHomolog', error?.response?.data || error)
      return error
    })
}

